import React, { PureComponent } from "react";

export default class WithTitle extends PureComponent {
  render() {
    const { title, children, backgroundColor } = this.props;
    return (
      <div className="with-title">
        <div className="title" style={{ backgroundColor }}>
          {title}
        </div>
        <div className="content">{children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WithTitle.js